export default __webpack_public_path__ + "static/media/image-26.b4fb2f56.png";